import script from "./ConfiguratorProductDecorator.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfiguratorProductDecorator.vue?vue&type=script&setup=true&lang=ts"

import "./ConfiguratorProductDecorator.vue?vue&type=style&index=0&id=3b1e9e40&lang=css"

const __exports__ = script;

export default __exports__